export default "__VITE_ASSET__1a8ec9ea__"